/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".widget__messages[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;position:fixed;top:0;left:0;right:0;z-index:101}.widget-shell[_ngcontent-%COMP%]{pointer-events:none;position:fixed;top:0;bottom:0;left:0;right:0;z-index:99999;border:var(--widget-shell-border)}"];
export { styles as styles };
